import React from "react";
import Grid from "@mui/material/Grid2"; 
import { Box, Typography, Card, CardContent, Chip } from "@mui/material";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { InsuranceCoverage } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { colorInsuranceType } from "../../../../utils/colorEnumFormatter";
import { formatInsuranceType } from "../../../../utils/pensionEnumFormatter";
interface PremiumPeriodInfoCardProps {
    coverage: InsuranceCoverage;
  }
// פונקציה ליצירת נתוני גרף מהתקופות
const generateChartData = (premiumPeriods: { start_period?: string; end_period?: string; premium_amount?: number }[]) => {
  return premiumPeriods.map((period) => ({
    year: period.start_period?.substring(0, 4) || "N/A", // לוקח רק את השנה מתוך YYYYMM
    premium: period.premium_amount ?? 0, // אם אין ערך, מחזיר 0
  }));
};

// ✅ קומפוננטה להצגת תקופות פרמיה עם גרף
const PremiumPeriodInfoCard: React.FC<PremiumPeriodInfoCardProps> = ({ coverage }) => {
  if (!coverage.premium_period || coverage.premium_period.length === 0) return null;

  const chartData = generateChartData(coverage.premium_period);

  return (
    <Card sx={{ mb: 2, p: 2 }}>
      <CardContent>
        <Grid container spacing={2}>
          {/* שם כיסוי */}
          <Grid size={{ xs: 6, md: 4 }}>
            <Typography variant="body2" fontWeight="bold">שם כיסוי:</Typography>
          </Grid>
          <Grid size={{ xs: 6, md: 8 }}
           sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 1, 
            flexWrap: "nowrap", // ✅ מונע ירידה לשורה חדשה
            overflow: "hidden",
          }}>
            <Typography>{coverage.coverage_name || "-"}</Typography>
             {/* ✅ הצגת CHIP של סוג ביטוח ליד שם כיסוי */}
             {coverage.coverage_details?.insurance_kind && (
              <Chip 
                label={formatInsuranceType(coverage.coverage_details.insurance_kind)}
                sx={{
                  backgroundColor: colorInsuranceType(coverage.coverage_details.insurance_kind),
                  color: "#fff",
            
                  height: "24px"
                }}
              />
            )}
          </Grid>

          {/* מספר כיסוי */}
          <Grid size={{ xs: 6, md: 4 }}>
            <Typography variant="body2" fontWeight="bold">מספר כיסוי:</Typography>
          </Grid>
          <Grid size={{ xs: 6, md: 8 }}>
            <Typography>{coverage.coverage_number || "-"}</Typography>
          </Grid>

          {/* תקופת פרמיה */}
          <Grid size={{ xs: 6, md: 4 }}>
            <Typography variant="body2" fontWeight="bold">תקופת פרמיה:</Typography>
          </Grid>
          <Grid size={{ xs: 6, md: 8 }}>
            <Typography>
            {coverage.premium_period[coverage.premium_period.length - 1].end_period?.substring(0, 4) || ""}&nbsp; - &nbsp;
              {coverage.premium_period[0].start_period?.substring(0, 4) || ""}  
             
            </Typography>
          </Grid>
        </Grid>

        {/* גרף עם הפרמיות לאורך התקופה */}
        <Box sx={{ height: 300, mt: 2 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData}>
              {/* ✅ רק קווי גריד אופקיים */}
              <CartesianGrid strokeWidth={1} vertical={false} />

              {/* ✅ ציר X עם מרווח נכון */}
              <XAxis 
                dataKey="year" 
                label={{ value: "שנה", position: "insideBottom", offset: -5 }}
                tick={{ fontSize: 12 }} 
              />

              {/* ✅ ציר Y - כותרת זזה שמאלה והתוויות מופרדות מהציר */}
              <YAxis 
                label={{ value: "פרמיה צפויה", angle: -90, position: "insideLeft", dx: 3 }}
                tick={{ fontSize: 12, dx: -22 }} 
              />

              <Tooltip />
              <Line type="monotone" dataKey="premium" stroke="#8884d8" strokeWidth={2} dot={{ r: 4 }} />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PremiumPeriodInfoCard;
